enum GAEventCategory {
    USER = "User",
    REPORT = "Report"
}

export default GAEventCategory;